import React from "react";
import styled from "styled-components";
// import about_1 from "../images/about_1.jpeg";
import about_1 from "../images/ollivanders-1.jpg";
import { PageHero } from "../components";

const About = () => {
  return (
    <>
      <PageHero title="about"></PageHero>
      <Wrapper>
        <img src={about_1} alt="shopPhoto" className="image" />
        <div className="about">
          <h1>Our Story</h1>
          <div></div>
          <p>
            Driven by their passion and armed with their knowledge of the
            wizarding world, the founders embarked on a quest to curate an
            extensive collection of authentic witch/wizard merchandise. They
            scoured the magical depths of Diagon Alley (metaphorically, of
            course!) and formed partnerships with trusted suppliers, ensuring
            that every product in the store captured the essence and magic of
            the beloved series.
            <br />
            <br />
            From the beginning, the store's mission has been to provide fans
            with a wide range of high-quality merchandise that caters to their
            diverse interests and preferences. Whether it's replica wands,
            house-themed apparel, home decor, collectibles, or accessories, the
            Ollivander's Store aimed to be a one-stop destination for all things
            magical.
          </p>
        </div>
      </Wrapper>
    </>
  );
};

const Wrapper = styled.section`
  padding: 5% 10vw;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 4rem;
  > .image {
    width: 100%;
    display: block;
    border-radius: 5px;
    height: 500px;
    object-fit: cover;
  }
  .about {
    > h1 {
      font-size: 2.5rem;
    }
    > div {
      width: 5rem;
      height: 5px;
      background-color: var(--color-primary-3);
    }
    > p {
      line-height: 1.5;
      margin-top: 2rem;
      text-align: justify;
    }
  }
  @media screen and (max-width: 650px) {
    > .image {
      height: 50vh;
    }
  }
`;

export default About;
